import { render } from "./insure-team-worker.vue?vue&type=template&id=5061deec&scoped=true&ts=true"
import script from "./insure-team-worker.vue?vue&type=script&lang=ts"
export * from "./insure-team-worker.vue?vue&type=script&lang=ts"

import "./insure-team-worker.vue?vue&type=style&index=0&id=5061deec&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5061deec"]])

export default __exports__